import request from '@/router/axios';

export const add = (row) => {
  return request({
    url: '/api/produce/rail-weighbridge-record/insert',
    method: 'post',
    data: row
  })
}
export const update = (row) => {
  return request({
    url: '/api/produce/rail-weighbridge-record/update',
    method: 'post',
    data: row
  })
}
export const getDetail = (id) => {
  return request({
    url: '/api/produce/rail-weighbridge-record/selectId',
    method: 'get',
    params: {
      id
    }
  })
}
export const getList = (params) => {
  return request({
    url: '/api/produce/rail-weighbridge-record/selectPage',
    method: 'get',
    params
  })
}
export const getPrintPreview = (params) => {
  return request({
    url: '/api/produce/rail-weighbridge-record/print-preview',
    method: 'get',
    params
  })
}
export const exportPdf = (params) => {
  return request({
    url: '/api/produce/rail-weighbridge-record/export-pdf',
    method: 'get',
    params,
    responseType: 'blob'
  })
}
export const remove = (ids) => {
  return request({
    url: '/api/produce/rail-weighbridge-record/deleteIds',
    method: 'get',
    params: {
      ids
    }
  })
}

